(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("styled-components"), require("react"), require("react-dom"), require("vue"));
	else if(typeof define === 'function' && define.amd)
		define(["styled-components", "react", "react-dom", ], factory);
	else if(typeof exports === 'object')
		exports["microlink"] = factory(require("styled-components"), require("react"), require("react-dom"), require("vue"));
	else
		root["microlink"] = factory(root["styled-components"], root["react"], root["react-dom"], root["Vue"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__0ed8__, __WEBPACK_EXTERNAL_MODULE__7037__, __WEBPACK_EXTERNAL_MODULE__7dac__, __WEBPACK_EXTERNAL_MODULE__8bbf__) {
return 